import { Star, Instagram, Facebook, Twitter, Calendar, Youtube } from 'lucide-react';

// Improved TikTok icon component
const TikTok = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    className={className}
    style={{ transform: 'translate(-2px, -2px)' }}
  >
    <path d="M28.5 10.5c-2.5 0-4.5-2-4.5-4.5h-4v18c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4c.3 0 .7 0 1 .1v-4.1c-.3 0-.7-.1-1-.1-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8V14.5c1.2 1 2.7 1.5 4.5 1.5v-5.5z" />
  </svg>
);

// Helper function to render stars for ratings
export const renderStars = (rating = 5, maxRating = 5) => {
  return (
    <div className="flex items-center">
      {[...Array(maxRating)].map((_, index) => (
        <Star 
          key={index} 
          className={`w-4 h-4 ${index < rating ? 'text-amber-400 fill-amber-400' : 'text-gray-200'} mr-0.5`} 
        />
      ))}
      <span className="text-gray-500 text-sm ml-2">({rating}.0)</span>
    </div>
  );
};

// Render social media icons
export const renderSocialLinks = (socialLinks) => {
  const { instagram, facebook, twitter, youtube, tiktok } = socialLinks;
  return (
    <div className="flex justify-center items-center space-x-3">
      {instagram && (
        <a href={`https://instagram.com/${instagram}`} target="_blank" rel="noopener noreferrer" className="border border-purple-300 rounded-full p-3 hover:bg-purple-50 transition-colors transform hover:scale-110">
          <Instagram className="h-5 w-5 text-purple-600" />
        </a>
      )}
      {facebook && (
        <a href={`https://facebook.com/${facebook}`} target="_blank" rel="noopener noreferrer" className="border border-purple-300 rounded-full p-3 hover:bg-purple-50 transition-colors transform hover:scale-110">
          <Facebook className="h-5 w-5 text-purple-600" />
        </a>
      )}
      {twitter && (
        <a href={`https://twitter.com/${twitter}`} target="_blank" rel="noopener noreferrer" className="border border-purple-300 rounded-full p-3 hover:bg-purple-50 transition-colors transform hover:scale-110">
          <Twitter className="h-5 w-5 text-purple-600" />
        </a>
      )}
      {youtube && (
        <a href={`https://youtube.com/${youtube}`} target="_blank" rel="noopener noreferrer" className="border border-purple-300 rounded-full p-3 hover:bg-purple-50 transition-colors transform hover:scale-110">
          <Youtube className="h-5 w-5 text-purple-600" />
        </a>
      )}
      {tiktok && (
        <a href={`https://tiktok.com/@${tiktok}`} target="_blank" rel="noopener noreferrer" className="border border-purple-300 rounded-full p-3 hover:bg-purple-50 transition-colors transform hover:scale-110">
          <TikTok className="h-5 w-5 text-purple-600" />
        </a>
      )}
    </div>
  );
};

// Render expertise areas as tags
export const renderExpertiseTags = (expertiseAreas) => {
  return (
    <div className="flex flex-wrap gap-2 mt-4">
      {expertiseAreas.map((expertise, index) => (
        <span 
          key={index} 
          className="px-1 py-1 bg-purple-50 text-purple-700 rounded-full text-xs font-small"
        >
          {expertise}
        </span>
      ))}
    </div>
  );
};

// Scroll handlers for carousel
export const scroll = (ref, direction) => {
  if (ref.current) {
    const scrollAmount = direction === 'left' ? -300 : 300;
    ref.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  }
};

// Render booking button
export const renderBookingButton = (calendarBookingPage) => {
  return (
    <a 
      href={calendarBookingPage}
      target="_blank"
      rel="noopener noreferrer"
      className="px-6 py-3 bg-gradient-to-r from-purple-600 to-purple-800 text-white font-medium rounded-lg inline-flex items-center justify-center hover:shadow-lg transition-all w-full"
    >
      <Calendar className="w-5 h-5 mr-2" />
      Book a Consultation
    </a>
  );
}; 